<template>
  <div>
    <v-text-field
        v-model="selectedTherapies"
        label="Therapies"
        append-icon="mdi-pencil"
        class="pointer"
        readonly
        @click="showDialog"
        @click:append="showDialog"
    />
    <v-dialog
        v-model="dialog"
        max-width="800"
        persistent
        scrollable
    >
      <dialog-loading v-if="loading" />
      <v-card v-else-if="incidentDataModel">
        <v-card-title>
          Edit Therapies
        </v-card-title>
        <v-card-text>
          <template v-if="isNewTherapies">
            <div
                v-if="!incidentDataModel.therapies.length"
                class="text-center"
            >
              No Therapies
            </div>
            <template
                v-for="(item, index) in incidentDataModel.therapies"
            >
              <v-row v-bind:key="'therapy_row_' + index">
                <v-col cols="5">
                  <v-select
                      v-model="item.therapy"
                      :items="therapiesList"
                      :label="'Therapy' + (index + 1)"
                      item-value="code"
                      item-text="name"
                      :return-object="false"
                  />
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      v-model="item.tm"
                      :label="'TMNumber' + (index + 1)"
                      type="number"
                  />
                </v-col>
                <v-col
                    cols="2"
                    class="text-right"
                >
                  <v-btn
                      icon
                      class="mt-5"
                      @click="deleteItem(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </template>
          <template
              v-for="number in 10"
              v-else
          >
            <v-row v-bind:key="'therapy_row_' + number">
              <v-col>
                <v-select
                    v-model="incidentDataModel['TR_Therapy' + number]"
                    :items="therapiesList"
                    :label="'Therapy' + number"
                    item-value="code"
                    item-text="name"
                    :return-object="false"
                    clearable
                />
              </v-col>
              <v-col>
                <v-text-field
                    v-model="incidentDataModel['TR_TMNumber' + number]"
                    :label="'TMNumber' + number"
                />
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn
              v-if="isNewTherapies"
              text
              @click="addNewTherapy"
          >
            + Add Therapy
          </v-btn>
          <v-spacer/>
          <v-btn
              class="mr-2"
              @click="dialog = false;"
          >
            Cancel
          </v-btn>
          <v-btn
              color="primary"
              @click="applyChanges"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirmation ref="confirmationPopup" />
  </div>
</template>
<script>
import _ from 'lodash';
import apiLookup from '@/api/lookup';
import DialogLoading from '@/components/DialogLoading';
import Confirmation from '@/components/Confirmation';

export default {
  name: 'TherapiesFields',
  components: { Confirmation, DialogLoading },
  props: {
    field: {
      type: Object,
    },
    incidentData: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      therapies: [],
      incidentDataModel: null,
    };
  },
  computed: {
    isNewTherapies() {
      return Object.prototype.hasOwnProperty.call(
        this.incidentData,
        'therapies',
      );
    },
    selectedTherapies() {
      if (this.isNewTherapies) {
        const { therapies } = this.incidentData;
        const therapiesFiltered = therapies
          .filter(item => item.therapy && item.tm)
          .map(item => `${item.therapy} - TM:${item.tm}`);
        return therapiesFiltered.join(', ');
      }

      const therapiesFilled = [];
      for (let number = 1; number <= 10; number++) {
        if (this.incidentData[`TR_Therapy${number}`]) {
          const therapy = this.incidentData[`TR_Therapy${number}`];
          const tm = this.incidentData[`TR_TMNumber${number}`];
          therapiesFilled.push(`${therapy} - TM:${tm}`);
        }
      }
      return therapiesFilled.join(', ');
    },
    therapiesList() {
      return this.therapies.map(item => ({
        code: item.code,
        name: `${item.code} - ${item.name}`,
      }));
    },
  },
  methods: {
    async showDialog() {
      this.incidentDataModel = _.cloneDeep(this.incidentData);
      this.dialog = true;
      try {
        this.loading = true;
        const response = await apiLookup.fetchTherapies();
        this.therapies = response.results;
      } finally {
        this.loading = false;
      }
    },
    applyChanges() {
      if (this.isNewTherapies) {
        this.incidentData.therapies = this.incidentDataModel.therapies;
      } else {
        for (let number = 1; number <= 10; number++) {
          this.incidentData[`TR_Therapy${number}`] = this.incidentDataModel[`TR_Therapy${number}`];
          this.incidentData[`TR_TMNumber${number}`] = this.incidentDataModel[`TR_TMNumber${number}`];
        }
      }
      this.dialog = false;
    },
    deleteItem(index) {
      this.$refs.confirmationPopup.showConfirm(
        'Delete Therapy ',
        'Do you really want to delete the therapy?',
        async () => {
          this.incidentDataModel.therapies.splice(index, 1);
        },
      );
    },
    addNewTherapy() {
      this.incidentDataModel.therapies.push({
        therapy: null,
        tm: null,
      });
    },
  },
};
</script>
